import ContentGuide from 'global/guides/ContentGuide'
import React from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'
import { Escalas, escalas } from 'service/api/endpoints/escalas'
import { columns } from 'templates/Cadastro/Escalas/columns'

const EscalaPage: React.FC = () => {
    const { data, isLoading } = escalas.useFetch()

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header label={['Cadastros', 'Escala']} />
                <ContentGuide.DataGrid
                    rows={data}
                    columns={columns}
                    onAdd
                    loading={isLoading}
                />
            </ContentGuide.Card>
            <Outlet context={{ data }} />
        </ContentGuide>
    )
}

export default EscalaPage

export const useEscalasOutletContext = () => {
    return useOutletContext<{
        data: Escalas[]
    }>()
}
